"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgFamilySelected = function SvgFamilySelected(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.067 30.507s0-1.236.78-1.236c.781 0 .813 1.236.813 1.236l1.92 17.383s.214 2.227 2.56 2.227 1.386-2.227 1.386-2.227l-1.918-28.1 6.248 6.679s2.553 4.04 4.497 3.135c1.943-.904-.195-3.135-.195-3.135l-9.756-11.653S15.416 13 12.66 13H8.948c-3.147 0-4.792 1.918-4.706 6.188.085 4.27-.96 13.213-.96 13.213s-.992 2.663 1.488 2.663 2.291-1.956 2.291-1.956V20.8v26.835s-.915 2.474 1.403 2.48c2.602 0 2.435-2.05 2.435-2.05l.167-17.558Z",
    fill: "#fff",
    stroke: "url(#family-selected_svg__a)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.796 11.592a4.796 4.796 0 1 0 0-9.592 4.796 4.796 0 0 0 0 9.592Z",
    fill: "#fff",
    stroke: "url(#family-selected_svg__b)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.583 32.038c.307 2.113.737 4.05.737 4.05H37.203h7.362V47.6s1.184 2.445-.856 2.445-2.25-2.084-2.25-2.084V36.09h-1.303l-.044 11.871s-.247 2.07-2.173 2.084c-1.926.013-.736-2.445-.736-2.445V36.09h-3.726l2.256-17.876-4.759 7.992s-1.258-1.06-2.974-1.341c2.246-3.882 3.856-6.842 5.976-9.748 2.12-2.905 7.093-3.112 7.093-3.112s5.166-.128 6.198 3.814c1.032 3.943 1.377 11.883 1.377 11.883s1.514 3.369-.78 4.203c-2.292.834-2.426-3.04-2.426-3.04l-.712-10.192.712 10.193s.149 3.592 2.145 3.173Z",
    fill: "#fff",
    stroke: "url(#family-selected_svg__c)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.796 10.592a4.796 4.796 0 1 0 0-9.592 4.796 4.796 0 0 0 0 9.592Z",
    fill: "#fff",
    stroke: "url(#family-selected_svg__d)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.871 22.743a3.871 3.871 0 1 0 0-7.743 3.871 3.871 0 0 0 0 7.743Z",
    fill: "#fff",
    stroke: "url(#family-selected_svg__e)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m25.573 37.706-.96 10.528s.615 2.468-1.062 2.468-1.488-2.468-1.488-2.468l.96-12.133v-8.62l-5.682-4.22s-1.714-1.181-1.237-2.568c.476-1.386 2.702 0 2.702 0s3.299 2.708 4.745 3.485c1.447.777 3.297.906 3.297.906s4.04.474 4.45 2.866c.41 2.393.41 7.741.41 7.741s.885 3.892-1.254 3.892c-1.64 0-1.49-9.953-1.49-9.953v9.953l.486 8.651s.929 2.468-.716 2.468-1.723-1.67-1.723-1.67l-.709-11.325h-.729Z",
    fill: "#fff",
    stroke: "url(#family-selected_svg__f)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "family-selected_svg__a",
    x1: 28.277,
    y1: 50.116,
    x2: 28.277,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2080F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "family-selected_svg__b",
    x1: 15.592,
    y1: 11.592,
    x2: 15.592,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2080F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "family-selected_svg__c",
    x1: 49.246,
    y1: 50.044,
    x2: 49.246,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2080F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "family-selected_svg__d",
    x1: 45.592,
    y1: 10.592,
    x2: 45.592,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2080F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "family-selected_svg__e",
    x1: 31.743,
    y1: 22.743,
    x2: 31.743,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2080F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "family-selected_svg__f",
    x1: 16,
    y1: 50.702,
    x2: 16,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2080F1"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgFamilySelected);
var _default = exports["default"] = Memo;